
namespace TabAurous.Reports {

    @Serenity.Decorators.registerClass()
    export class PriceBifurcationGrid extends Serenity.EntityGrid<PriceBifurcationRow, any> {
        protected getColumnsKey() { return 'Reports.PriceBifurcation'; } 
        protected getIdProperty() { return PriceBifurcationRow.idProperty; }
        protected getInsertPermission() { return PriceBifurcationRow.insertPermission; }
        protected getLocalTextPrefix() { return PriceBifurcationRow.localTextPrefix; }
        protected getService() { return PriceBifurcationService.baseUrl; }
        public vouchertypeid: number;

        constructor(container: JQuery) {
            super(container);

            this.setTitle("");
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass == "");
            buttons.push({
                title: 'Filters',
                cssClass: 'send-button',
                icon: 'fa-filter',
                onClick: () => {
                    var dialog = new Common.FiltersDialog;
                    dialog.filterformfor = "Transaction";

                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            (this.view.params as ReportFiltersRequest).VoucherTypeId = dialog.vouchertypeid;
                            this.vouchertypeid = dialog.vouchertypeid;
                            var vouchernos = dialog.vouchernos;
                            var partyids = dialog.partyids;
                            //this.onViewSubmit();
                            this.view.refresh();
                            PriceBifurcationService.List({ VoucherTypeId: dialog.vouchertypeid, VoucherNos: vouchernos, PartyIds: partyids }, response => { this.view.setItems(response.Entities) }, { async: false });
                        }
                    });
                }
            });
            buttons.push({
                title: 'Export',
                cssClass: 'send-button',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }
                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    if (this.vouchertypeid == 55) {
                        Q.postToService({
                            service: PriceBifurcationService.baseUrl + '/SalesQuotationExportExcel',
                            request: {
                                PriceBifurcationItems: items,
                            },

                            target: '_blank'
                        });
                    } else {
                        Q.postToService({
                            service: PriceBifurcationService.baseUrl + '/OrderDetailSelectedExportExcel',
                            request: {
                                PriceBifurcationItems: items,
                            },

                            target: '_blank'
                        });
                    }
                }
            });
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Price Bifurcation"
            }));
            buttons.push(Serenity.ColumnPickerDialog.createToolButton(this as any));
            return buttons;
        }
        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params;

            //var vouchertypeid = request.EqualityFilter.VoucherTypeId;
            //var voucherno = request.EqualityFilter.VoucherNo;
            //var partyids = request.EqualityFilter.PartyId;
            //(this.view.params as ReportFiltersRequest).VoucherTypeId = vouchertypeid;
            //(this.view.params as ReportFiltersRequest).VoucherNo = voucherno;
            //(this.view.params as ReportFiltersRequest).PartyIds = partyids;

            //var x = this.getQuickFilters(); 
            return true;
        }

    
    }
}